import { Copy } from 'lucide-react';
import { useToast } from '../../components/ui/toastContext';
import { copyToClipboard } from './utils';

/**
 * ID 展示与复制行：缩短展示 Agent ID，点击按钮复制完整 ID 到剪贴板。
 */
export default function IdCopy({ id, label = 'ID' }: { id: string; label?: string }) {
  const toast = useToast();
  const short = id.replace(/-/g, '');
  return (
    <span className="id-copy-row">
      <span>{label}: {short.slice(0, 8)}...{short.slice(-6)}</span>
      <button
        className="secondary"
        title="复制完整 ID"
        onClick={async () => {
          const ok = await copyToClipboard(id);
          if (ok) {
            toast.success('ID 已复制');
          } else {
            toast.error('复制失败');
          }
        }}
      >
        <Copy size={12} />
      </button>
    </span>
  );
}
